export default __webpack_public_path__ + "static/media/rnr-sports-table-4-cn.54eccc52.webp";